<template>
  <section class="section dark">
    <div class="container container-small">
      <div class="tile" v-for="(tile, index) in tiles" :key="index"
      :class="{
        active: index == activeItem
      }"
      @click="setActive(index)"
      >
        <div class="tile-header">
          <TextSection
            :header="tile.header"
            :description="tile.description"
            :underline="true"
            :uppercase="false"
            :cutLength="570"
            :cutLengthTextBig ="460"
          />
        </div>
        <span class="number">{{ (index + 1) }}</span>
      </div>
    </div>
  </section>
</template>

<script>
import TextSection from '@/components/TextSection.vue'

export default {
  name: 'tilesSection',
  props: ['tiles'],
  components: {
    TextSection
  },
  data: function () {
    return {
      activeItem: 0
    }
  },
  methods: {
    // padNumber (num) {
    //   var s = String(num)
    //   while (s.length < 2) {
    //     s = '0' + s
    //   }
    //   return s
    // },
    setActive (index) {
      this.activeItem = index
    }
  }
}
</script>

<style scoped lang="scss">
  section {
    &.dark {
      background-color: $bg-dark;
    }
    .container {
      display: flex;
      flex-flow: row nowrap;
      max-width: calc(90vw - 222px);
      @include desktop {
        max-width: calc(88% + 64px);
        width: 1038px;
      }
      @include desktop-small {
        width: 100%;
      }
      @include mobile {
        max-width: 88%;
      }
    }
    // flex-wrap: nowrap;
    // align-content: stretch;
  }
  .tile {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-content: flex-end;
    background-color: $bg-dark;
    color: $text-light;
    min-height: 422px;
    cursor: pointer;
    transition: $transition;
    border-left: 1px solid rgba($color: #fff, $alpha: 0.1);
    width: 100%;
    // @include desktop-small {
      // &:first-child {
      //   border-left: none;
      // }
    // }
    &:last-child {
      border-right: 1px solid rgba($color: #fff, $alpha: 0.1);
      // @include desktop-small {
      //   border-right: none;
      // }
    }
    padding: 20px 20px 0;
    user-select: none;
    &-header {
      display: none;
      pointer-events: none;
      padding: 10px 12px 0;
      width: 100%;
      max-width: 500px;
      min-height: 270px;

      @include screen ('sm') {
        min-width: 300px;
      }
      @include screen ('lg') {
        padding-right: 3em;
        min-width: 500px;
      }
      /deep/ .parts-wrapper {
        // width: 450px;
        width: 100%;
        margin: 20px 0 10px 0;
        p {
          font-weight: 400;
        }
        h2 {
          margin-bottom: 20px;
        }
        @include desktop {
          // width: 400px;
          margin: 20px 0 10px 0;
        }
      }
    } // END .tile-header;
    &.active {
      flex: 2 auto;
      width: 100%;
      // flex-grow: 2;
      .tile-header {
        display: block;

        // user-select: inherit;
        @include tablet {
          position: absolute;
          top: 40px;
          left: 0;
          // width: 100%;
          // max-width: 100%;
          min-height: 226px;
          padding: 10px 0 0;
        }
        @include mobile {
          position: absolute;
          top: 152px;
        }
        @include mobile-small {
          top: 142px;
        }
        // opacity: 1;
        // width: 100%;
        // height: 100%;
      } // END .tile-header;
      @include tablet {
        .number {
          opacity: 1;
          color: $text-accent;
        }
      }
    }
    &:hover {
      .number {
        opacity: 1;
        color: $text-accent;
      }
    }
    @include desktop {
      min-height: 454px;
      header {
        min-height: 300px;
      }
    }
    @include tablet {
      min-height: 54px;
      margin-top: 250px;
      user-select: none;
      align-content: center;
      .font-size-l & {
        margin-top: 310px;
      }
    }
    @include mobile {
      margin-top: 37px;
      margin-bottom: 410px;
      padding: 0 10px;
      .font-size-l & {
        margin-top: 37px;
        margin-bottom: 470px;
      }
    }
    @include mobile-small {
      margin-top: 37px;
      margin-bottom: 530px;
      padding: 0 4px;
      .font-size-l & {
        margin-top: 37px;
        margin-bottom: 580px;
      }
    }
  }
  .number {
    font-size: 102px;
    opacity: 0.2;
    font-weight: bold;
    padding: 0 0.1em;
    align-self: flex-end;
    transition: none;
    display: flex;
    user-select: none;
    &:focus {
      outline: none;
    }
    // @include desktop-big {
    //   padding: 0;
    // }
    @include mobile {
      font-size: 60px;
      line-height: 74px;
    }
    @include mobile-small {
      font-size: 50px;
      line-height: 64px;
    }
  }
</style>
